import { message } from "antd";
import axios from "axios";
import globalRouter from "globalRouter.ts";

const SECONDS = 30;
const MILISECONDS = 1000;
const TIMEOUT = SECONDS * MILISECONDS;
const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;

const PrivateNetworkClient = axios.create({
    baseURL: REACT_APP_BASE_API,
    timeout: TIMEOUT,
    headers: {
        "Content-Type": "application/json",
    },
});

PrivateNetworkClient.interceptors.request.use(config => {
    const jwtToken = localStorage.getItem("token")
    if (jwtToken) {
        config.headers["authorization"] = 'Bearer ' + jwtToken
    }
    // The client-wide JSON Content-Type makes axios serialise FormData to JSON,
    // which multipart endpoints reject (415). Let the browser set the boundary.
    if (config.data instanceof FormData) {
        config.headers.delete("Content-Type")
    }
    if (!jwtToken && !config.headers["public-request"]) {
    }
    return config
}, error => {
    return Promise.reject(error)
})

const PERMISSION_DENIED_KEY = "permission-denied";
const PERMISSION_DENIED_FALLBACK = "You do not have permission to do that.";
// Background queries (the dashboard polls every few seconds) would otherwise
// raise the same toast again as soon as the previous one closed.
const BACKGROUND_REPEAT_MS = 30 * MILISECONDS;
let lastDenied = { content: null, at: 0 };

const notifyPermissionDenied = (error) => {
    const data = error?.response?.data;
    // Export endpoints use responseType "blob", so there is no message to read.
    const content = (data && typeof data === "object" && typeof data.message === "string" && data.message)
        || PERMISSION_DENIED_FALLBACK;
    const isRead = (error?.config?.method || "get").toLowerCase() === "get";
    const now = Date.now();
    if (isRead && lastDenied.content === content && now - lastDenied.at < BACKGROUND_REPEAT_MS) {
        return;
    }
    lastDenied = { content, at: now };
    // A shared key replaces a visible toast instead of stacking another.
    message.error({ content, key: PERMISSION_DENIED_KEY });
};

PrivateNetworkClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // 403 is a denied action, not an expired session: tell the user and stay signed in.
        if (error?.response?.status === 403) {
            notifyPermissionDenied(error);
            return Promise.reject(error);
        }
        if (error?.response?.data) {
            if (error.response.status === 401) {
                localStorage.removeItem('token');
                globalRouter.navigate("/login", { state: { message: "" } });
            } else {
                if (error?.response?.data?.errorMessages) {
                    return Promise.reject(error);
                } else {
                    message.error(error?.response?.data?.message);
                }

            }
        } else if (error.response.status !== 200) {
            if (error.response.status === 401) {
                // localStorage.removeItem('token');
                // globalRouter.navigate("/login", { state: { message: "" } });
            } else {
                message.error(error.response.data.data);
            }
        } else {
            console.error(error);
        }
        return Promise.reject(error);
    }
);

export default PrivateNetworkClient;